export const MDM_GROUPS = {
  ADD_GROUP: 'Add Group',
  NO_GROUPS: 'No groups found',
  HOSTS: 'hosts',
  POLICIES: 'Policies',
  POLICIES_COUNT: (count: number) => `Policies (${count})`,
  NO_POLICIES: 'No policies',
  BASELINE_COMPLIANCE: 'Baseline compliance',
  COMPLIANT_HOSTS: (compliant: number, total: number) => `${compliant}/${total} ${total === 1 ? 'host' : 'hosts'}`,
  SUMMARY: (groups: number, assigned: number, total: number) =>
    `${groups} ${groups === 1 ? 'group' : 'groups'} · ${assigned} of ${total} ${total === 1 ? 'host' : 'hosts'} assigned`,
  HOSTS_COUNT: (count: number) => `Hosts (${count})`,
  NO_DEVICES: 'No devices in this group',
  GROUP_DETAILS: 'Group Details',
  NEW_GROUP: 'New Group',
  CREATE_GROUP: 'Create Group',
  CANCEL: 'Cancel',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  PLATFORM: 'Platform',
  ENTER_GROUP_NAME: 'Enter group name',
  ENTER_GROUP_DESCRIPTION: 'Enter group description',
  TITLE: 'Groups',
  SELECT_HOSTS: 'Select hosts',
  ADD_MORE_HOSTS: 'Add more hosts',
  SEARCH_HOSTS: 'Search hosts...',
  LOADING_HOSTS: 'Loading hosts...',
  NO_HOSTS_FOUND: 'No hosts found',
  NO_HOSTS_FOR_PLATFORM: 'No hosts for this platform',
}

export const MDM_GROUPS_MESSAGES = {
  CREATED: 'Group created successfully',
  FAILED_TO_CREATE: 'Failed to create group',
  NAME_CONFLICT: (name: string) => `A group named "${name}" already exists, please choose another name.`,
}

export const MDM_GROUPS_DELETE_DIALOG = {
  TITLE: 'Delete Group',
  QUESTION: 'Are you sure you want to delete',
  CONFIRMATION: 'This action cannot be undone.',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
}

export const MDM_GROUPS_PLATFORMS = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  IOS: 'iOS',
  ANDROID: 'Android',
  ALL: 'All',
  ALL_PLATFORMS: 'All Platforms',
}
